<script>
    import { ItemType, itemsInfo, ItemId } from 'json/itemsInfo.js'
    import { buildSources, requestMajesticClothes, glyphClass } from './itemPhoto.js'
    import { executeClient } from 'api/rage'

    export let item;
    export let defaultIcon;
    export let defaultName;
    export let defaultStyle;
    export let selcetinv;

    let value = 1;

    let iconInfo = itemsInfo [item.ItemId];

    let sources = [];
    let index = 0;
    let lastKey = "";

    $: if (item) {
        iconInfo = itemsInfo [item.ItemId];
        const key = item.ItemId + "|" + (item.Data || "");
        if (key !== lastKey) {
            lastKey = key;
            sources = buildSources(item, iconInfo);
            index = 0;
            // одежда: адрес у маджестика приходит асинхронно (хеш модели считает клиент)
            requestMajesticClothes(item, (url) => {
                if (key !== lastKey || sources.indexOf(url) >= 0) return;
                sources = [url, ...sources];
                index = 0;
            });
        }
    }

    // промах: следующий источник, а когда они кончились — глиф иконо-шрифта
    const nextSource = () => {
        index = (index < sources.length - 1) ? index + 1 : sources.length;
    };

    $: currentSrc = sources[index] || "";
    $: showGlyph = !currentSrc;

    const Bool = (text) => {
        return String(text).toLowerCase() === "true";
    }

    const GetClothesClass = (_iconInfo, _item) => {
        if (_iconInfo.functionType === ItemType.Clothes && _item.ItemId != -5 && _item.ItemId != -9 && _item.ItemId != -1 && _item.Data.split("_").length >= 2) {
            return Bool(item.Data.split("_")[2]) ? "clothesM" : "clothesF"
        }
        return "";
    }

    const useitem = (item) => {
        executeClient ("client.gamemenu.inventory.stack", "other", item.Index, 2, value);
    }

    const dropitem = (item) => {
        executeClient ("client.gamemenu.inventory.stack", "inventory", item.Index, 2, value);
    }

</script>
{#if item && item.ItemId != 0}
    <div class="itemblock">
        <div class="leftib">
            {#if showGlyph}<span class="{glyphClass(iconInfo)}" style="font-size:3vh;line-height:1;display:flex;align-items:center;justify-content:center;color:#c9c9d4" />{:else}<img src="{currentSrc}" alt="" on:error={nextSource}>{/if}
        </div>
        <div class="rightib">
            <h1>{itemsInfo [item.ItemId].Name} {#if defaultIcon === undefined && iconInfo.functionType === 1 && item.ItemId != -5 && item.ItemId != -9 && item.ItemId != -1 && item.Data.split("_").length >= 2}{Bool(item.Data.split("_")[2]) ? "М" : "Ж"}{/if}</h1>
            <p>{itemsInfo [item.ItemId].Description}</p>
            {#if item.Count > 1 }
                <span>{item.Count}<b>шт..</b></span>
                {:else}
                <span></span>
            {/if}
            {#if item.Count > 1 }
                <div class="kolvo">
                    <input bind:value={value}>
                    <div class="btnskolv">
                        <p on:keypress={() => {}} on:click={(e) => { e.stopPropagation(); value = value > 0 ? value - 1 : value;}}>-</p>
                        <p on:keypress={() => {}} on:click={(e) => { e.stopPropagation(); value = value < item.Count ? value + 1 : value;}}>+</p>
                    </div>
                    <div class="btnskolv">
                        <p on:keypress={() => {}} on:click={(e) => { e.stopPropagation(); value = 1;}}>Min</p>
                        <p on:keypress={() => {}} on:click={(e) => { e.stopPropagation(); value = item.Count; }}>Max</p>
                    </div>
                </div>
            {/if}
            {#if selcetinv}
                <div class="btnuse" on:keypress={() => {}} on:click={(e) => { e.stopPropagation(); useitem(item); }}>
                    <p>Взять</p>
                </div>
                {:else}
                <div class="btnuse" on:keypress={() => {}} on:click={(e) => { e.stopPropagation(); dropitem(item); }}>
                    <p>Положить</p>
                </div>
            {/if}
        </div>
    </div>
{/if}
